import { translate } from 'containers/services/translate';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import { get, isEmpty } from 'lodash';
import userPrivelges from 'containers/services/security/user-privileges';
import { Listings } from 'containers/AppContainer/typings';
import { LISTINGS } from 'containers/data-structure';
import { LAWYER_INTERVENANT_TYPE } from 'containers/AppContainer/constants';

type messageType = {
  [name: string]: {
    id: string;
  };
};

export const getTabLabels = (messages: messageType, props: unknown) => {
  if (featureService.hasFeature(FEATURES.JUDGEMENT_APPEAL)) {
    return [
      translate(messages.procesVerbal, props),
      translate(messages.judgementAdd, props),
      translate(messages.expertReport, props),
      translate(messages.judgementOnTheMerits, props),
      translate(messages.arretAdd, props),
      translate(messages.expertReportAppeal, props),
      translate(messages.appealOnMerits, props),
    ];
  } else {
    return [
      translate(messages.procesVerbal, props),
      translate(messages.judgementAdd, props),
      translate(messages.expertReport, props),
      translate(messages.judgementOnTheMerits, props),
    ];
  }
};
export const getTabLabelsV2 = (messages: messageType, props: unknown) => {
  if (featureService.hasFeature(FEATURES.ATTRIBUTION_INBOXES_MANAGER)) {
    let titles: any = [];
    userPrivelges.getUserInboxes().flatMap((el: any) => {
      if (el.managerInboxe.title === 'Décision et notification') {
        titles.push(
          ...[
            translate(messages.procesVerbal, props),
            translate(messages.judgementAdd, props),
            translate(messages.judgementOnTheMerits, props),
            translate(messages.arretAdd, props),
            translate(messages.appealOnMerits, props),
          ],
        );
        return titles;
      } else if (el.managerInboxe.title === 'Rapport Judiciaire') {
        titles.push(
          ...[
            translate(messages.expertReport, props),
            translate(messages.expertReportAppeal, props),
          ],
        );
        return titles;
      } else {
        return [];
      }
    });
    return titles;
  } /* istanbul ignore next */ else if (
    featureService.hasFeature(FEATURES.JUDGEMENT_APPEAL)
  ) {
    return [
      translate(messages.procesVerbal, props),
      translate(messages.judgementAdd, props),
      translate(messages.expertReport, props),
      translate(messages.judgementOnTheMerits, props),
      translate(messages.arretAdd, props),
      translate(messages.expertReportAppeal, props),
      translate(messages.appealOnMerits, props),
    ];
  } else {
    /* istanbul ignore next */ return [
      translate(messages.procesVerbal, props),
      translate(messages.judgementAdd, props),
      translate(messages.expertReport, props),
      translate(messages.judgementOnTheMerits, props),
    ];
  }
};
export const getProp = (props: any, key: string) => {
  let value = props[key];
  if (value === null) {
    return '';
  }
  return value;
};
export const showValidator = (validator: String, isManager: boolean) =>
  !isEmpty(validator);

export const resolveAmountFeeNoteTtc = (
  amountTtc: number,
  decisionDate: any,
) => {
  if (decisionDate) {
    const date = new Date(decisionDate);
    const year = date.getFullYear();
    if (year < 2023) {
      const oldValue = Math.round(amountTtc / 1.2);
      return Math.round(oldValue * 1.1);
    }
  }
  return amountTtc;
};

export const resolveAmountFeeNoteHt = (amountTtc: number) => {
  const oldValue = Math.round(amountTtc / 1.2);
  return oldValue;
};
export const getDateIgnoreTimezone = (date: any) =>
  date && date.getUTCHours() !== 0
    ? (theDate =>
        new Date(theDate.getTime() - theDate.getTimezoneOffset() * 60 * 1000))(
        new Date(date),
      )
    : date;

export const isUserActive = (listings: Listings, lawyerCode: string) =>
  !!get(listings, LISTINGS.INTERVENANT_NAME, [])
    .filter((el: any) => el.ItemType === LAWYER_INTERVENANT_TYPE)
    .find((el: any) => el.ItemKey === lawyerCode);
